import { useEffect } from 'react';
import { useAuth } from '../context/auth.context';
import { UserActionTypes, useUser } from '../context/user.context';
import { useParams } from 'react-router';
import LoginLoader from './login-loader.component';
import { type LoginProps } from './login.component';
import LoginSchema, { useLoginSchema } from './login-schema.component';
import { DEFAULT_IDP } from '../helpers/constants';

export default function LoginIdp({ onLoginSuccess, redirectPath, loginQueryParams }: LoginProps) {
  const { signinRedirect } = useAuth();
  const { state, dispatch } = useUser();
  const { onSchemaSelected } = useLoginSchema(redirectPath, onLoginSuccess);
  const { idp } = useParams();

  const { auth: isAuthenticated, tokens } = state;

  useEffect(() => {
    if (!isAuthenticated) {
      // When the idp domain is specified as part of the URL path,
      // then the user can directly go to the IdP login page (defaults to the MyOSH IdP)
      // and bypass the `myosh-login` Login page
      const _idp = idp ?? DEFAULT_IDP;

      dispatch({
        type: UserActionTypes.UpdateUser,
        payload: {
          auth: false,
          idp: _idp,
          isDefaultIdp: _idp === DEFAULT_IDP,
          loginStatus: 'idp',
        },
      });

      signinRedirect(_idp, loginQueryParams);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {!isAuthenticated && <LoginLoader title="Loading" />}
      {isAuthenticated && tokens && <LoginSchema idToken={tokens.id_token} onSchemaSelected={onSchemaSelected} />}
    </>
  );
}
